import React, { useState } from 'react';
import './PixelCat3D.css';
import cat1 from './assets/smaug1.png';
import cat2 from './assets/smaug2.png';
import cat3 from './assets/smaug3.png';
import cat4 from './assets/smaug4.png';

const PixelCat3D = () => {
  const [rotation, setRotation] = useState(0);
  const [hearts, setHearts] = useState([]);

  // Auto-rotate continuously
  React.useEffect(() => {
    const interval = setInterval(() => {
      setRotation(prev => (prev + 0.5) % 360); // Rotate 0.5 degrees every interval
    }, 50); // Update every 50ms for smooth rotation

    return () => clearInterval(interval);
  }, []);

  // Handle click to show hearts
  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    
    // Create 3-5 hearts that spread out from center
    const numHearts = 3 + Math.floor(Math.random() * 3); // 3-5 hearts
    
    for (let i = 0; i < numHearts; i++) {
      const newHeart = {
        id: Date.now() + Math.random(),
        x: centerX,
        y: centerY,
        angle: (Math.random() * 360), // Random direction
        distance: 40 + Math.random() * 60, // How far to spread
        delay: i * 50 // Stagger the hearts slightly
      };
      
      setHearts(prev => [...prev, newHeart]);
      
      // Remove heart after animation
      setTimeout(() => {
        setHearts(prev => prev.filter(h => h.id !== newHeart.id));
      }, 2000 + newHeart.delay);
    }
  };

  return (
    <div className="pixel-cat-3d-container">
      {/* 3D Cat Display */}
      <div className="cat-display-screen">
        <div className="screen-header">✿ THE SMAUG MACHINE ✿</div>
        <div className="cat-viewport" onClick={handleClick}>
          <div 
            className="cat-3d-wrapper"
            style={{ transform: `rotateY(${rotation}deg)` }}
          >
            {/* Front face */}
            <div className="cat-face cat-front">
              <img src={cat1} alt="Cat" className="cat-image" />
            </div>
            {/* Back face */}
            <div className="cat-face cat-back">
              <img src={cat3} alt="Cat" className="cat-image" />
            </div>
            {/* Left face */}
            <div className="cat-face cat-left">
              <img src={cat2} alt="Cat" className="cat-image" />
            </div>
            {/* Right face */}
            <div className="cat-face cat-right">
              <img src={cat4} alt="Cat" className="cat-image" />
            </div>
            {/* Top face */}
            <div className="cat-face cat-top">
            </div>
            {/* Bottom face */}
            <div className="cat-face cat-bottom"></div>
          </div>
          
          {/* Scan lines for retro effect */}
          <div className="cat-scanlines"></div>
          
          {/* Floating hearts */}
          {hearts.map(heart => (
            <div
              key={heart.id}
              className="pixel-heart"
              style={{
                left: `${heart.x}px`,
                top: `${heart.y}px`,
                '--angle': `${heart.angle}deg`,
                '--distance': `${heart.distance}px`,
                animationDelay: `${heart.delay}ms`
              }}
            >
              ♡
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PixelCat3D;